import React, { useRef, useState, useEffect } from "react";
import { i18n } from "idc-ui-react";
import { t } from "@lingui/macro";
// Fluent UI
import {
  Stack,
  ChoiceGroup,
  PrimaryButton,
  DefaultButton,
  DialogFooter,
  Text,
  Link
} from "@fluentui/react";

export default function TwoFA(props) {
  const { store, handleDismiss, options } = props;
  const { urls, apiCall, state } = store;
  const { loggedInUser } = state;
  const choiceGroup = useRef(null);

  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(undefined);
  const [hoveredItem, setHoveredItem] = useState(undefined);

  useEffect(() => {
    const newOptions = options.map(option => {
      if (option.iconLink && option.iconLink.length > 0) {
        return {
          key: option.name,
          text: option.device,
          imageSrc: option.iconLink,
          imageAlt: option.device,
          ...option
        };
      } else {
        return {
          key: option.name,
          text: option.device,
          iconProps: {
            id: option.name,
            iconName: option.iconName
          },
          ...option
        };
      }
    });

    setItems(newOptions);
    setSelectedItem(
      newOptions.find(option => option.key === loggedInUser.mfaType)
    );
  }, [options, loggedInUser.mfaType]);

  function setOnMouseOver(ev) {
    // Hack to capture mouseOver on choiseGroup
    const iArray = ev.target.getElementsByTagName("I");
    const imgArray = ev.target.getElementsByTagName("IMG");

    // Icon option
    if (iArray && iArray.length === 1) {
      if (iArray[0].id) {
        setHoveredItem(items.find(item => item.name === iArray[0].id));
      }
      return;
    }

    // Image option
    if (imgArray && imgArray.length === 1) {
      if (imgArray[0].alt) {
        setHoveredItem(items.find(item => item.name === imgArray[0].alt));
      }
      return;
    }
  }

  const change2fa = async () => {
    await apiCall.post(`${urls.api.me}/mfa?provider=${selectedItem.key}`);
    const newLoggedInUser = loggedInUser;
    newLoggedInUser.mfaType = selectedItem.key;
    store.updateLoggedInUser(newLoggedInUser);
    if (selectedItem.key === "GOOGLE") {
      window.location.href = urls.logout;
    } else {
      handleCancel();
    }
  };

  const handleCancel = () => {
    setSelectedItem(undefined);
    handleDismiss();
  };

  return (
    <Stack
      styles={{
        root: {
          height: "fit-content",
          width: "500px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }}
    >
      <Stack
        styles={{
          root: {
            padding: "20px",
            border: "1px solid black"
          }
        }}
      >
        <Text
          variant="large"
          styles={{
            root: { paddingBottom: "15px" }
          }}
        >
          <b>
            {i18n._(
              t`Access to ID Connect always requires a two-step verification.`
            )}
          </b>
        </Text>
        <ChoiceGroup
          componentRef={choiceGroup}
          selectedKey={
            selectedItem && selectedItem.key
              ? selectedItem.key
              : loggedInUser.mfaType
          }
          options={items}
          onChange={(e, item) => setSelectedItem(item)}
          label={i18n._(t`Select 2-Step Verification`)}
          onMouseMove={e => setOnMouseOver(e)}
        />
        {selectedItem && selectedItem.description && (
          <Stack
            styles={{
              root: {
                paddingTop: "20px"
              }
            }}
          >
            <Text variant="medium">
              {hoveredItem && hoveredItem.description
                ? hoveredItem.description
                : selectedItem.description}
            </Text>
            <Link
              href={
                hoveredItem && hoveredItem.helpLink
                  ? hoveredItem.helpLink
                  : selectedItem.helpLink
              }
              target="_blank"
            >
              {i18n._(
                t`Learn more about ${
                  hoveredItem && hoveredItem.device
                    ? hoveredItem.device
                    : selectedItem.device
                }`
              )}
            </Link>
          </Stack>
        )}
        <Stack
          styles={{
            root: {
              display: "flex",
              flexDirection: "row",
              paddingTop: "20px"
            }
          }}
        >
          <DialogFooter>
            <DefaultButton text={i18n._(t`Cancel`)} onClick={handleCancel} />
            <PrimaryButton
              text={i18n._(t`Save`)}
              disabled={
                !selectedItem ||
                (selectedItem.key && selectedItem.key === loggedInUser.mfaType)
              }
              onClick={change2fa}
            />
          </DialogFooter>
        </Stack>
      </Stack>
    </Stack>
  );
}
